import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SUPABASE_URL, supabaseHeaders } from '../supabase';
import { uploadPoster } from '../utils/imageUpload';
import { tagAtPatchOnCreate } from '../utils/tagTimestamps';

function GamesForm({ onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const prefill = location.state || {};
  const [form, setForm] = useState({
    title: prefill.title || '',
    rating: '',
    thoughts: '',
    playedWithJoy: false,
    playedWithRick: false,
    playedWithLisa: false,
    playedWithGionnan: false,
    playedWithYoussra: false,
  });
  const [poster, setPoster] = useState(null);
  const [posterPreview, setPosterPreview] = useState(null);
  const [prefillPosterUrl] = useState(prefill.posterUrl || null);
  const [todoGameId] = useState(prefill.todoGameId || null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.rating) {
      setStatus('Please fill in a title and rating.');
      return;
    }

    setLoading(true);
    setStatus('');

    try {
      let posterUrl = null;
      if (poster) posterUrl = await uploadPoster(poster);
      else if (prefillPosterUrl) posterUrl = prefillPosterUrl;

      const payload = {
        title: form.title,
        rating: parseFloat(form.rating),
        played_with_joy: form.playedWithJoy,
        played_with_rick: form.playedWithRick,
        played_with_lisa: form.playedWithLisa,
        played_with_gionnan: form.playedWithGionnan,
        played_with_youssra: form.playedWithYoussra,
        thoughts: form.thoughts || '',
        ...tagAtPatchOnCreate([
          { isOn: form.playedWithJoy, atField: 'played_with_joy_at' },
          { isOn: form.playedWithRick, atField: 'played_with_rick_at' },
          { isOn: form.playedWithLisa, atField: 'played_with_lisa_at' },
          { isOn: form.playedWithGionnan, atField: 'played_with_gionnan_at' },
          { isOn: form.playedWithYoussra, atField: 'played_with_youssra_at' },
        ]),
      };

      if (posterUrl) payload.poster_url = posterUrl;

      const res = await fetch(`${SUPABASE_URL}/rest/v1/games`, {
        method: 'POST',
        headers: { ...supabaseHeaders(true), Prefer: 'return=representation' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('Failed to create');

      if (todoGameId) {
        await fetch(`${SUPABASE_URL}/rest/v1/todo_games?id=eq.${todoGameId}`, {
          method: 'DELETE',
          headers: supabaseHeaders(true),
        });
      }

      setStatus('Saved :D');
      if (onClose) {
        setTimeout(() => onClose(), 1500);
      } else {
        setTimeout(() => navigate('/Games'), 1500);
      }
    } catch (err) {
      console.error(err);
      setStatus(`Something went wrong: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (onClose) {
    return (
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <h2 style={{ fontFamily: 'angelWish', fontSize: '2rem', letterSpacing: '0.06em', marginBottom: 0 }}>Add Game</h2>
        <div className="form-group">
          <label>Title *</label>
          <input type="text" name="title" value={form.title} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Rating *</label>
          <input
            type="number"
            name="rating"
            value={form.rating}
            onChange={handleChange}
            min="1"
            max="10"
            step="0.1"
            required
          />
        </div>

        <div className="form-group">
          <label>Thoughts</label>
          <textarea name="thoughts" value={form.thoughts} onChange={handleChange} rows={4} />
        </div>

        <div className="form-group">
          <label>Poster</label>
          {(posterPreview || (prefillPosterUrl && !poster)) && (
            <img src={posterPreview || prefillPosterUrl} alt="poster" style={{ width: 80, borderRadius: 4, marginBottom: '0.4rem' }} />
          )}
          <input type="file" accept="image/*" onChange={(e) => { const f = e.target.files[0]; setPoster(f); setPosterPreview(f ? URL.createObjectURL(f) : null); }} />
        </div>

        <div className="form-group">
          <label>With</label>
          <div className="form-checkboxes">
            <label><input type="checkbox" name="playedWithJoy" checked={form.playedWithJoy} onChange={handleChange} /> Joy &lt;3</label>
            <label><input type="checkbox" name="playedWithRick" checked={form.playedWithRick} onChange={handleChange} /> Rick</label>
            <label><input type="checkbox" name="playedWithLisa" checked={form.playedWithLisa} onChange={handleChange} /> Lisa</label>
            <label><input type="checkbox" name="playedWithGionnan" checked={form.playedWithGionnan} onChange={handleChange} /> Gionnan</label>
            <label><input type="checkbox" name="playedWithYoussra" checked={form.playedWithYoussra} onChange={handleChange} /> Youssra</label>
          </div>
        </div>

        {status && <p className="form-status">{status}</p>}
        <div className="edit-modal-actions">
          <button type="button" className="form-submit" onClick={onClose} style={{ background: 'white', color: 'black', WebkitTextFillColor: 'black' }}>Cancel</button>
          <button type="submit" disabled={loading} className="form-submit">
            {loading ? 'Loading...' : 'Add Game'}
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className="app-container">
      <form onSubmit={handleSubmit} className="movie-form">
        <h1 style={{ fontFamily: 'angelWish', fontSize: '4rem', letterSpacing: '0.06em', marginTop: 0, marginBottom: 0 }}>Add Game</h1>
        <div className="form-group">
          <label>Title *</label>
          <input type="text" name="title" value={form.title} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Rating *</label>
          <input
            type="number"
            name="rating"
            value={form.rating}
            onChange={handleChange}
            min="1"
            max="10"
            step="0.1"
            required
          />
        </div>

        <div className="form-group">
          <label>Thoughts</label>
          <textarea name="thoughts" value={form.thoughts} onChange={handleChange} rows={4} />
        </div>

        <div className="form-group">
          <label>Poster</label>
          {(posterPreview || (prefillPosterUrl && !poster)) && (
            <img src={posterPreview || prefillPosterUrl} alt="poster" style={{ width: 80, borderRadius: 4, marginBottom: '0.4rem' }} />
          )}
          <input type="file" accept="image/*" onChange={(e) => { const f = e.target.files[0]; setPoster(f); setPosterPreview(f ? URL.createObjectURL(f) : null); }} />
        </div>

        <div className="form-group">
          <label>With</label>
          <div className="form-checkboxes">
            <label><input type="checkbox" name="playedWithJoy" checked={form.playedWithJoy} onChange={handleChange} /> Joy &lt;3</label>
            <label><input type="checkbox" name="playedWithRick" checked={form.playedWithRick} onChange={handleChange} /> Rick</label>
            <label><input type="checkbox" name="playedWithLisa" checked={form.playedWithLisa} onChange={handleChange} /> Lisa</label>
            <label><input type="checkbox" name="playedWithGionnan" checked={form.playedWithGionnan} onChange={handleChange} /> Gionnan</label>
            <label><input type="checkbox" name="playedWithYoussra" checked={form.playedWithYoussra} onChange={handleChange} /> Youssra</label>
          </div>
        </div>

        <button type="submit" disabled={loading} className="form-submit">
          {loading ? 'Loading...' : 'Add Game'}
        </button>

        {status && <p className="form-status">{status}</p>}
      </form>
    </div>
  );
}

export default GamesForm;
